export default "__VITE_ASSET__DhofqKKm__"